module.exports = __webpack_public_path__ + "img/EMT-PDAC_GSE111672.1956d96e.png";